module.exports = __webpack_public_path__ + "img/jgold.10e90021.jpg";